var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 513,
    viewBox: "0 0 120 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_836_3626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 514
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 513.134,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_836_3626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 59.4824H-1.06897V29.2413H29.1721V59.4824Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 59.4824H29.1722V29.2413H59.4133V59.4824Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 89.7231H29.1722V59.482H59.4133V89.7231Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 119.964H-1.06897V89.7233H29.1721V119.964Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 150.206H-1.06897V119.964H29.1721V150.206Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 150.206H29.1722V119.964H59.4133V150.206Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 180.446H29.1722V150.205H59.4133V180.446Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 119.964H59.4133V89.7233H89.6544V119.964Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 210.688H-1.06897V180.446H29.1721V210.688Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 240.929H-1.06897V210.688H29.1721V240.929Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 240.929H29.1722V210.688H59.4133V240.929Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 271.17H29.1722V240.929H59.4133V271.17Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 210.688H59.4133V180.446H89.6544V210.688Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 301.411H-1.06897V271.17H29.1721V301.411Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 331.652H-1.06897V301.411H29.1721V331.652Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 331.652H29.1722V301.411H59.4133V331.652Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 361.893H29.1722V331.652H59.4133V361.893Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 301.411H59.4133V271.17H89.6544V301.411Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 392.134H-1.06897V361.893H29.1721V392.134Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 422.375H-1.06897V392.134H29.1721V422.375Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 422.375H29.1722V392.134H59.4133V422.375Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 452.617H29.1722V422.376H59.4133V452.617Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 392.134H59.4133V361.893H89.6544V392.134Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 482.857H-1.06897V452.616H29.1721V482.857Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 513.099H-1.06897V482.858H29.1721V513.099Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 513.099H29.1722V482.858H59.4133V513.099Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 482.857H59.4133V452.616H89.6544V482.857Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 59.4824H119.896V29.2413H89.6544V59.4824Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 119.964H119.896V89.7233H89.6544V119.964Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 180.446H119.896V150.205H89.6544V180.446Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 240.929H119.896V210.688H89.6544V240.929Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 301.411H119.896V271.17H89.6544V301.411Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 361.893H119.896V331.652H89.6544V361.893Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 422.375H119.896V392.134H89.6544V422.375Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 482.857H119.896V452.616H89.6544V482.857Z",
    fill: "#AA00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 89.7231H-1.06897V59.482H29.1721V89.7231Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 59.4824H59.4133V29.2413H89.6544V59.4824Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 89.7231H59.4133V59.482H89.6544V89.7231Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 119.964H29.1722V89.7233H59.4133V119.964Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 180.446H-1.06897V150.205H29.1721V180.446Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 150.206H59.4133V119.964H89.6544V150.206Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 180.446H59.4133V150.205H89.6544V180.446Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 210.688H29.1722V180.446H59.4133V210.688Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 271.17H-1.06897V240.929H29.1721V271.17Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 240.929H59.4133V210.688H89.6544V240.929Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 271.17H59.4133V240.929H89.6544V271.17Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 301.411H29.1722V271.17H59.4133V301.411Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 361.893H-1.06897V331.652H29.1721V361.893Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 331.652H59.4133V301.411H89.6544V331.652Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 361.893H59.4133V331.652H89.6544V361.893Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 392.134H29.1722V361.893H59.4133V392.134Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1721 452.617H-1.06897V422.376H29.1721V452.617Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 422.375H59.4133V392.134H89.6544V422.375Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 452.617H59.4133V422.376H89.6544V452.617Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 482.857H29.1722V452.616H59.4133V482.857Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6544 513.099H59.4133V482.858H89.6544V513.099Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.06897 29.2407H29.1721V-1.00038H-1.06897V29.2407Z",
    fill: "#0D058F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4133 29.2407H89.6544V-1.00038H59.4133V29.2407Z",
    fill: "#0D058F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalPurple);
export default __webpack_public_path__ + "static/media/verticalPurple.7da532bd2ad51ce5e4b7aa38e1276863.svg";
export { ForwardRef as ReactComponent };